// `extension-alert-candidates-message-no-valid-candidates-modal.tpl.html`, ported — "Selected
// candidates are missing email or blacklisted", shown when nobody in a message selection can be
// mailed (`shortlist.candidate-message.service.ng1.ts` `showNoValidCandidatesDialogue`).
//
// Upstream: `useUnifiedTemplate: true`, `windowClass: "dialog-unified shortlist-dialogue
// extension-candidates-modal-container modal-dialog-slim"`, no buttons and no auto-close — only
// the body's own ×, plus the unified shell's dismissals. `_extension-alert-candidates-modal.scss`
// is what makes it 180px (`&.modal-dialog-slim`) and draws the copy.
import type { ReactElement } from 'react'
import { UnifiedModal } from '../modal/UnifiedModal.tsx'

export interface NoValidCandidatesDialogueProps {
  /**
   * The contacts twin (`showNoValidClientContactsDialogue`) is a second template with the same
   * markup and window class; only the noun differs.
   */
  entity?: 'candidates' | 'contacts'
  /** The ×, Escape or a backdrop click. Upstream discards the result. */
  onClose: () => void
}

export function NoValidCandidatesDialogue({ entity = 'candidates', onClose }: NoValidCandidatesDialogueProps): ReactElement {
  return (
    <UnifiedModal
      open
      windowClass="dialog-unified shortlist-dialogue extension-candidates-modal-container modal-dialog-slim"
      onClose={onClose}
    >
      <div>
        <span className="extension-candidates-modal-text">
          <span>
            <i className="fa fa-exclamation-circle fa-lg extension-candidates-modal-negative" />
          </span>
          <span className="extension-candidates-modal-text-amount">
            Selected {entity} are missing email or blacklisted
          </span>
          <i className="far fa-times extension-candidates-modal-x cursor-pointer" onClick={onClose} />
        </span>
      </div>
    </UnifiedModal>
  )
}
